import { MapPin, Instagram, Mail } from "lucide-react";
import { Link } from "react-router-dom";

export const Footer = () => {
  return (
    <footer
      data-testid="site-footer"
      className="bg-black border-t border-zinc-900 py-14"
    >
      <div className="w-full max-w-7xl mx-auto px-6 sm:px-8 lg:px-12 grid sm:grid-cols-2 lg:grid-cols-4 gap-10">
        <div className="lg:col-span-2">
          <p className="font-display font-black text-2xl uppercase tracking-tight text-white">
            AITOR<span className="text-[#FF5A1F]">.</span>
          </p>
          <p className="text-zinc-500 text-sm mt-1 uppercase tracking-widest">
            Nutrición & Entrenamiento
          </p>
          <p className="mt-4 text-zinc-400 max-w-md text-sm leading-relaxed">
            Acompañamiento real para hombres +35 que quieren perder peso,
            recuperar energía y disfrutar de su familia.
          </p>
        </div>

        <div>
          <p className="text-xs uppercase tracking-widest text-zinc-500 font-bold">
            Contacto
          </p>
          <ul className="mt-4 space-y-3 text-zinc-300 text-sm">
            <li className="flex items-start gap-2">
              <MapPin size={14} className="text-[#FF5A1F] mt-1 shrink-0" />
              <span>
                C/ Berriobide
                <br />
                Pamplona, Navarra
              </span>
            </li>
            <li className="flex items-center gap-2">
              <Mail size={14} className="text-[#FF5A1F]" />
              <a
                href="#contacto"
                data-testid="footer-link-contact"
                className="hover:text-white"
              >
                Formulario de contacto
              </a>
            </li>
          </ul>
        </div>

        <div>
          <p className="text-xs uppercase tracking-widest text-zinc-500 font-bold">
            Síguenos
          </p>
          <ul className="mt-4 space-y-3 text-zinc-300 text-sm">
            <li className="flex items-center gap-2">
              <Instagram size={14} className="text-[#FF5A1F]" />
              <a
                href="#"
                data-testid="footer-link-instagram"
                className="hover:text-white"
              >
                @aitor.nutricion
              </a>
            </li>
          </ul>
        </div>
      </div>

      <div className="w-full max-w-7xl mx-auto px-6 sm:px-8 lg:px-12 mt-12 pt-6 border-t border-zinc-900 flex flex-col sm:flex-row justify-between items-center gap-3">
        <p className="text-xs text-zinc-600">
          © {new Date().getFullYear()} Aitor · Nutrición y Entrenamiento. Todos
          los derechos reservados.
        </p>
        <div className="flex items-center gap-5 text-xs text-zinc-500 uppercase tracking-widest">
          <Link
            to="/aviso-legal"
            data-testid="footer-link-aviso-legal"
            className="hover:text-[#FF5A1F] transition-colors"
          >
            Aviso legal
          </Link>
          <Link
            to="/politica-privacidad"
            data-testid="footer-link-privacidad"
            className="hover:text-[#FF5A1F] transition-colors"
          >
            Privacidad
          </Link>
          <span className="text-zinc-700">Pamplona · España</span>
        </div>
      </div>
    </footer>
  );
};
